import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({ description, lang, meta, title, image }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: `daily intentions, habit streaks, mood journal, bitcoin rewards, accountability community, daily habit app, earn bitcoin`,
        },
        {
          property: `og:title`,
          content: "Day: Make today Day One ☀️",
        },
        {
          property: `og:image`,
          content: "https://firebasestorage.googleapis.com/v0/b/perfect-day-19585.appspot.com/o/website%2Fsocial.png?alt=media&token=a1f68d4a-4dd7-4d6d-9e5d-cc97f49f0e9d",
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:site`,
          content: `Day: Make today Day One ☀️`,
        },
        {
          name: `twitter:creator`,
          content: `TheSchnaz`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:image`,
          content: `https://firebasestorage.googleapis.com/v0/b/perfect-day-19585.appspot.com/o/website%2Fsocial.png?alt=media&token=a1f68d4a-4dd7-4d6d-9e5d-cc97f49f0e9d`,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
